/*
 * File: project-view.ts
 * File Created: 2024-03-01 08:46:32
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2025-12-08 16:49:46
 * Modified By: Val Liu <valuis0429@gmail.com>
 * -----
 */

import { BaseView } from "@root/components";
import {
    DateHelper,
    FindRouter,
    IRegisterRouterInput,
    NumberHelper,
    ObjectHelper,
    StringHelper,
} from "@root/core";
import { Component, Provide } from "vue-property-decorator";
import { IQuickUnit, UIQuick } from "@root/core/utilities/quick-helper";

@Component
export class ProjectView extends BaseView {
    static quicks = UIQuick.getInstanceMap();
    quicks() {
        return ProjectView.quicks;
    }

    /// route info
    get routeInfo(): IRegisterRouterInput | null {
        const paths = [this.$route.path, `/${this.$route.path.split("/")[1]}`];
        for (let path of paths) {
            let routers = FindRouter({ path });
            if (routers.length === 0) continue;
            return routers[routers.length - 1];
        }
        return null;
    }
}
